import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/home.vue'), 
    // component: () => import(/* webpackChunkName: "about" */ '../views/aesModel/aesModel.vue'),  // 加密模型的
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../components/homevue/homevue.vue'),
      },
      {
        path: '/ability',
        name: 'ability',
        component: () => import(/* webpackChunkName: "about" */ '../components/abilityvue/abilityvue.vue'), 
      },
      {
        path: '/vipBuy',
        name: 'vipBuy',
        component: () => import(/* webpackChunkName: "about" */ '../components/vipBuy/vipBuy.vue'),
      },
      {
        path: '/personal',
        name: 'personal',
        component: () => import(/* webpackChunkName: "about" */ '../components/personal/personal.vue'),
      },
    ],
    meta: {
      title: '万康人体解剖'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/login.vue'),
  },
  {
    path: '/progress',
    name: 'progress',
    component: () => import(/* webpackChunkName: "about" */ '../components/progressTest/progressTest.vue'),
  },
  {
    path: '/model',
    name: 'model',
    component: () => import(/* webpackChunkName: "about" */ '../views/model/model.vue'),  //Model 
    // component: () => import(/* webpackChunkName: "about" */ '../views/model/animate.vue'),// 
  },  
  {
    path: '/silhouette',
    name: 'silhouette',
    component: () => import(/* webpackChunkName: "about" */ '../views/silhouette/silhouette.vue'),
  },
  {
    path: '/animate',
    name: 'animate',
    component: () => import(/* webpackChunkName: "about" */ '../views/animate/animate.vue'),
  }, 
]

const router = new VueRouter({
  mode: 'hash', 
  base: '/',
  routes
})

export default router
